import * as React from 'react'

import { styled } from '~/styled'

import { EmptyStateContext } from './EmptyState.context'

const StyledEmptyStateTitle = styled(
  'h2',
  {
    base: ['text-grey-800', 'font-body', 'font-semibold', 'm-0'],
    variants: {
      size: {
        xs: ['mb-3', 'text-md'],
        sm: ['mb-3', 'text-md'],
        md: ['mb-3', 'text-md'],
        lg: ['mb-4', 'text-lg'],
        xl: ['mb-4', 'text-lg']
      }
    }
  },
  { enabledResponsiveVariants: true }
)

type EmptyStateTitleProps = React.ComponentProps<
  typeof StyledEmptyStateTitle
> & {
  as?: React.ComponentType | React.ElementType
}

export const EmptyStateTitle = (props: EmptyStateTitleProps) => {
  const { size } = React.useContext(EmptyStateContext)
  return <StyledEmptyStateTitle size={size} {...props} />
}
